// extracted by mini-css-extract-plugin
module.exports = {"countdown":"kh","srOnly":"lh"};